import React, { useState, useEffect, ChangeEvent } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {CssBaseline, Typography,Box, Stack, Card as MuiCard, styled, Button, FormGroup, FormControlLabel, Checkbox, InputLabel } from '@mui/material';
import TextAreaWithButton from '../components/common/TextAreaWithButton';
import TextField from '@mui/material/TextField';
import Snackbar from '@mui/material/Snackbar';
import ContactUs from '../components/feature-specific/ContactUs';
import TermsAndCond from '../components/feature-specific/TermsAndCond';
import PopUpAlert from '../components/common/PopUpAlert';
import { useSnackbar } from '../SnackbarProvider';

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: 'auto',
  marginTop:"0px",
  [theme.breakpoints.up('sm')]: {
    maxWidth: '450px',
  },
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
}));

const InputWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3), // Adjust this value as needed
  position: 'relative',
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));



// Define the type for the form fields
interface BankDetailsForm {
  bankAcc: string;
  ifsc: string;
}

interface BankDetailsProps{
  mobileNumber:string;
  id:string;
  textDisabled:boolean;
  panNameMatch:boolean;
  aadharNameMatch:boolean;

  bankAcc:string;
  ifsc:string;
  bankVerified:boolean;
  bankNameMatch:boolean;
  setBankAcc:React.Dispatch<React.SetStateAction<string>>;
  setIfsc:React.Dispatch<React.SetStateAction<string>>;
  setBankVerified:React.Dispatch<React.SetStateAction<boolean>>;
  setBankNameMatch:React.Dispatch<React.SetStateAction<boolean>>;
  setCurrentStep:React.Dispatch<React.SetStateAction<number>>;
}

const BankDetails: React.FC<BankDetailsProps> = ({mobileNumber,id,textDisabled,panNameMatch,aadharNameMatch,bankAcc,ifsc,bankVerified,bankNameMatch,setBankAcc,setIfsc,setBankVerified,setBankNameMatch,setCurrentStep}) => {
  // const [bankAcc, setBankAcc] = useState<string>(''); // State for bank account
  // const [ifsc, setIfsc] = useState<string>(''); // State for IFSC code
  const [bankAccError, setBankAccError] = useState<boolean>(false); // Error state for bank account validation
  const [ifscError, setIfscError] = useState<boolean>(false); // Error state for IFSC code validation
  const [errorMessage,setErrorMessage] = useState<string>('')
  const [reqSent, setReqSent] = useState<boolean>(false);
  const navigate = useNavigate();
  
  const [tncAccepted, setTncAccepted] = useState<boolean>(false);
  const [linkClicked, setLinkClicked] = useState<boolean>(false);
  const [warning,setWarning] = useState<boolean>(false);
  const {showSnackbar} = useSnackbar();

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;

    switch (name) {
      case 'bankAcc':
        setBankAcc(value);
        setBankAccError(false);
        setIfscError(false);
        // validateBankAcc(value);
        break;
      case 'ifsc':
        setIfsc(value);
        // validateIfsc(value);
        setBankAccError(false);
        setIfscError(false);
        break;
      default:
        break;
    }
  };

  const validateBankAcc = (value: string): boolean => {
    const bankAccRegex = /^\d{9,18}$/; // Regex for bank account number
    const isValid = bankAccRegex.test(value); // Test the value against the regex
    setWarning(false);
    if(!isValid)setErrorMessage('Invalid account number. Must be 9 to 18 digits.');
    setBankAccError(!isValid); // Set error based on regex match
    return isValid; // Return the validity of the bank account number
  };
  
  const validateIfsc = (value: string): boolean => {
    const ifscRegex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/; // Regex for IFSC code
    const isValid = ifscRegex.test(value); // Test the value against the regex
    setWarning(false);
    setErrorMessage('Invalid IFSC code. Must be 11 characters long.');
    setIfscError(!isValid); // Set error based on regex match
    return isValid; // Return the validity of the IFSC code
  };
  interface UserDataResponse {
    responseCode: number;
    responseMessage: string;
    data:{
      verificationStatus:boolean;
    }
  }

  // Handle form submission with Axios
  const handleSubmit = async (): Promise<void> => {
    if(validateIfsc(ifsc) && validateBankAcc(bankAcc)){
      // console.log('here2');
      const token = localStorage.getItem('authToken');
            const headers = {
              Authorization: `Bearer ${token}`,
            };
        try {
          setErrorMessage('');
          // Axios API call to submit the bank details
            const id = localStorage.getItem('id');
            const mobileNumber = localStorage.getItem('mobile');
            setReqSent(true);
          const response = await axios.post<UserDataResponse>(`https://promoter-api.benow.in/api/kyc/v1/auth/register`, { merchantId:id, mobileNumber:mobileNumber,identityNumber:bankAcc,ifscCode:ifsc.toUpperCase(),actionType:"3" },
                { headers}
          );
          // Check response status
          if (response.status === 200 && response.data.data.verificationStatus===true) {
            setBankNameMatch(true);
            setBankVerified(true);
            setCurrentStep(3);
            showSnackbar("Bank details verified successfully",'success');
            // You can navigate to another page or reset the form here
          } else if(response.status === 200 && response.data.data.verificationStatus===false){
            setBankVerified(true);
            setCurrentStep(3);
            setBankNameMatch(false);
            setWarning(true);
            setIfscError(true);
            setErrorMessage(' Your details will be verified manually.');
            showSnackbar('Name Mismatch','warning');
          }
          else if(response.status === 200 ){
            showSnackbar("Server Error.",'warning');
            setBankVerified(true);
            setBankNameMatch(false);
            // setWarning(true);
            setIfscError(true);
            setErrorMessage('Your details will be verified manually.');
            // setReqSent(false);
          }
        } catch (error:any) {
          if(error.status===400 && error.response?.data?.responseCode===400){
            showSnackbar("Invalid Details.",'warning');
            setBankVerified(false);
            setBankNameMatch(false);
            setErrorMessage('Invalid Details! ');
            setReqSent(false);
          }
          else if(error.status === 400){
            showSnackbar("Unable to verify.",'warning');
            setBankVerified(false);
            setBankNameMatch(false);
            setWarning(true);
            setIfscError(true);
            setErrorMessage('Unable to verify! ');
            setReqSent(false);
          }
          else{
            console.error('Error submitting bank details:', error);
            setWarning(false);
            setBankVerified(false);
            setBankNameMatch(false);
            setReqSent(false);
            setIfscError(true);
            setErrorMessage('Unknown error occurred. Please try later.')
            showSnackbar('Unknown error occurred. Please try later.','error');
          }
        }
      }
      else if(!validateBankAcc){
        setWarning(false);
        setBankAccError(true);
        setErrorMessage('Invalid account number. Must be 9 to 18 digits.');
      }
      else if(!validateIfsc){
        setWarning(false);
        setIfscError(true);
        setErrorMessage('Invalid IFSC code. Must be 11 characters long.');
      }
      // else{
      //   setWarning(true);
      //   setIfscError(true);
      //   setErrorMessage('ServerError');
      // }
    
  };
  const sendMessage = async()=>{
    const mobile = localStorage.getItem('mobile');
    const id = localStorage.getItem('id');
    const response = await axios.post('https://promoter-api.benow.in/api/kyc/v1/auth/send-sms',{mobileNumber:mobile,smsFlowType:(panNameMatch&&aadharNameMatch&&bankNameMatch)?'GREEN_FLOW':'AMBER_FLOW',merchantId:id});
  }

  const handleFinish=async()=>{
    await sendMessage();
    navigate('/summary',{state:{aadharNameMatch,panNameMatch,bankNameMatch}});
  }

  const [minVal, setMinVal] = useState<number>(0); // State for minimum value
  const [maxVal, setMaxVal] = useState<number>(0); // State for maximum value
  const [temp1, setTemp1] = useState<number|undefined>(undefined);
  const [temp2, setTemp2] = useState<number|undefined>(undefined);
  interface PromoterGradesResponse {
    countThreshold: number;
    incentiveAmount: number;
  }
  
      const fetchValues = async () => {
        const token = localStorage.getItem('authToken');
        const headers = {
          Authorization: `Bearer ${token}`,
        };
        const mobile = localStorage.getItem('mobile');
          try {
            const phone = localStorage.getItem('mobile');
            const id = localStorage.getItem('id');
              const response = await axios.get<PromoterGradesResponse[]>(`https://promoter-api.benow.in/api/kyc/v1/auth/promoter-grades/${phone}`,{headers}); // Update the URL as necessary
              console.log(response.data);
              if(response.data.length===1){
                setMinVal(response.data[0].countThreshold);
                setMaxVal(response.data[0].incentiveAmount);
                setTemp1(undefined);
                setTemp2(undefined);
              }
              else if(response.data.length===2){
                setMinVal(response.data[0].countThreshold);
                setMaxVal(response.data[0].incentiveAmount);
                setTemp1(response.data[1].countThreshold);
                setTemp2(response.data[1].incentiveAmount);
              }
          } catch (error) {
              console.error('Error fetching values:', error);
          }
      };

      useEffect(() => {
        fetchValues();
      }, [bankVerified]);

      useEffect(()=>{
        if(!bankNameMatch){
          setIfscError(true);
          setWarning(true);
          setErrorMessage('Your Details wil be verified manually.')
        }
      },[bankNameMatch]);

      const handleIfscInput = (value: string): void => {
        setIfsc(value); // Convert the string to uppercase
      };
  const handleCheck = () => {
    if(!linkClicked){
      showSnackbar("Please read TnC before accepting them",'error');
    }
    else{
      setTncAccepted((prev) => !prev);
    }
  };
  const handleClick = (): void => {
    setLinkClicked(true);
    const optionalParam1 = temp1; // Optional parameter
    const optionalParam2 = temp2;
    console.log(temp1);
    console.log(temp2);
    // Open the TnC page in a new tab with query parameters
    const url = `/terms-and-conditions?minVal=${minVal}&maxVal=${maxVal}${
      optionalParam1 ? `&optional1=${optionalParam1}` : ''
    }${optionalParam2 ? `&optional2=${optionalParam2}` : ''}`;
    window.open(url, '_blank'); // Opens the URL in a new tab
  };
  return (
<>
      <CssBaseline enableColorScheme />
      <SignInContainer direction="column" justifyContent="space-between">
        <InputWrapper>
          <InputLabel shrink htmlFor="text-field"
      sx={{ fontSize: '1.8rem' }}
      >
         <b>Bank Account Number </b>
        </InputLabel>
        <TextField
          fullWidth
          id="text-field"
          variant="outlined"
          label=""
          name="bankAcc"
          type="text"
          value={bankAcc}
          onChange={handleChange}
          error={bankAccError}
          disabled={reqSent || textDisabled || bankVerified}
          sx={{
            '& .MuiOutlinedInput-root.Mui-disabled': {
            backgroundColor: bankVerified ? '#e8f5e9' : '#f0f0f0', // Green for verified, light grey for default disabled
            color: bankVerified ? '#2e7d32' : '#000000', // Text color for verified
          },
          '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d3d3d3', // Set this to the default or custom color you want
          },
        }}
        color={bankVerified ? "success" : "secondary"}
        />
        {errorMessage && bankAccError &&(
            <Typography 
            color={warning ? 'orange' : 'error'} 
            fontSize="10px" 
            position="absolute" 
            bottom="-20px"
          >
            {errorMessage}
          </Typography>
          )
          }
        </InputWrapper>
        <InputWrapper>
            <TextAreaWithButton
              errorMessage={errorMessage}
              label="IFSC Code"
              inputValue={ifsc}
              onChange={handleIfscInput}
              onClick={handleSubmit}
              buttonText="Validate"
              ariaLabel="BankDetails"
              disabled={reqSent || textDisabled}
              prefilled={textDisabled}
              verified={bankVerified}
            />
          {errorMessage && ifscError &&(
            <Typography 
            color={warning ? 'orange' : 'error'} 
            fontSize="10px" 
            position="absolute" 
            bottom="-25px"
          >
            {errorMessage}
          </Typography>
          )
          }
        </InputWrapper>
        <InputWrapper>
          <FormGroup>
          <FormControlLabel
            required
            control={<Checkbox checked={tncAccepted} onChange={handleCheck} 
            />}
            // Checkbox label with a clickable link
            label={
              <span>
                <span
                  style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  onClick={handleClick}
                >
                  Read and Accept TnC
                </span>
              </span>
            }
          />
        </FormGroup>
        </InputWrapper>
          <Button variant="contained" disabled={!tncAccepted || !bankVerified } onClick={handleFinish}>SUBMIT</Button>
      </SignInContainer>
</>
  );
};

export default BankDetails;
